/** The app's ONLY auth entry point. NEXT_PUBLIC_AUTH_PROVIDER selects the
 *  implementation at BUILD time (NEXT_PUBLIC_* is inlined; unset ⇒ auth0 —
 *  the same prod-safe default convention as the backend's AUTH_PROVIDER).
 *  NOTE: both provider modules are statically imported, so both SDKs ship in
 *  the bundle regardless of flavor (~tens of KB gz overhead). If that ever
 *  matters, swap to the next.config.js alias mechanism the dev mock uses. */
import * as auth0 from "./providers/auth0";
import * as oidc from "./providers/oidc";

export type { AuthHook, AuthUser, GetTokenOptions, LoginOptions } from "./types";

const impl =
  process.env.NEXT_PUBLIC_AUTH_PROVIDER === "keycloak" ? oidc : auth0;

export const AuthProvider = impl.AuthProvider;
export const useAuth = impl.useAuth;
export const withAuthRequired = impl.withAuthRequired;
